/* eslint-disable @typescript-eslint/no-explicit-any */

import { School } from '@/types';

const BASE_URL = process.env.VUE_APP_BASE_URL;
/**
* `schoolgids` may also be a schoolplan
*/
export function schoolgidsUrl(schoolgids: { bestand: string; type: any }) {
  /**
  * Schoolgidsen die recentelijk geüpload zijn (lees: middels de API), hebben als `bestand` field
  * niet enkel de bestandsnaam, maar de gehele URL. Afhankelijk hiervan moet de schoolgids URL dus
  * dynamisch gegenereerd worden. (Als `bestand` geen url is, moet ie geprepend worden met
  * '../uploads/schoolgidsen/{type}/'. Anders kan `bestand` gewoon geretourneerd worden)
  */

  // A very simple/naive check, but it works fine
  const urlRegex = new RegExp(/^https?:\/\//, 'i');
  if (urlRegex.test(schoolgids.bestand)) {
    return schoolgids.bestand;
  }
  return `${BASE_URL}/uploads/schoolgidsen/${schoolgids.type}/${
    schoolgids.bestand
  }`;
}

export function inspectierapportUrl(inspectierapport: { bestands_locatie: string }, fallback: any) {
  const urlRegex = new RegExp(/^https?:\/\//, 'i');
  if (urlRegex.test(inspectierapport.bestands_locatie)) {
    return inspectierapport.bestands_locatie;
  }
  return fallback;
}

/**
 * Gegeven een bestuur, genereer de bestuur url
 */
export function bestuurUrl(bestuur: any) {
  return `${BASE_URL}/besturen/bestuur/${bestuur.bgn}`;
}

/**
 * Gegeven een school, genereer de school url
 */
export function schoolUrl(school: School) {
  return `${BASE_URL}/${school.type}/school/${school.brin}`;
}

/**
 * Tranformed een relatieve url naar een absolute scholenoverzicht url
 */
export function scholenoverzichtUrl(relativeUrl: string) {
  return `${BASE_URL}/${relativeUrl.replace(/^\//, '')}`;
}

/**
 * Uploads staan niet lokaal.. therefore misschien logischer om het rechtstreeks
 * naar de server te sturen. Momenteel zijn dit nog uploads in de codeigniter
 * omgeving
 */
export function uploadsUrl(path: string) {
  return `https://onderwijsconsument.nl/scholenoverzicht/uploads/${path}`;
}

export function jaarverslagUrl(jaarverslag: any) {
  if (jaarverslag.bestand.startsWith('https://')) {
    return jaarverslag.bestand;
  }
  return uploadsUrl(`jaarverslagen/${jaarverslag.bestand}`);
}

export function getLocation(url: string) {
  const a = document.createElement('a');
  a.href = url;
  return a;
}

export function parseQueryString(queryString: string) {
  const query = {} as any;
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (let i = 0; i < pairs.length; i += 1) {
    const pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}
